import $ from "jquery";

export class Slider {

    private lasttimeaction = 0;
    private isPlaying = true;

    constructor() {
        (<any>window).Slider = this;

        $(document).ready(function () {
            (<any>window).Slider.initSliders();
        });

        $(window).on("load", function () {
            (<any>window).Slider.loadOtherSliderimages();
        });

        $(window).on("resize", function () {
            (<any>window).Slider.loadOtherSliderimagesSizes();
        });

        //console.log("init slider", $(this).find(".toggle-autoplay").length);
    }


    loadOtherSliderimagesSizes() {
        $(".slider").each(function () {
            $(this).children(".imageholder").find(".image").each(function () {
                var imgClass = "img_dt";
                if ($(window).innerWidth() <= 760) {
                    imgClass = "img_800";
                } else if ($(window).innerWidth() <= 1250) {
                    imgClass = "img_1350";
                }
                $(this).find("IMG." + imgClass).each(function (e) {
                    if (typeof $(this).attr("data-src") != "undefined") {
                        $(this).attr("src", $(this).attr("data-src"));
                        $(this).removeAttr("data-src");
                    }
                });
            })
        });
    }

    loadOtherSliderimages() {
        $(".slider").each(function () {
            var imgCount = 0;
            $(this).children(".imageholder").find(".image").each(function () {
                imgCount++;
                if (imgCount > 1) {
                    var imgClass = "img_dt";
                    if ($(window).innerWidth() <= 760) {
                        imgClass = "img_800";
                    } else if ($(window).innerWidth() <= 1250) {
                        imgClass = "img_1350";
                    }
                    $(this).find("IMG." + imgClass).each(function (e) {
                        if (typeof $(this).attr("data-src") != "undefined") {
                            $(this).attr("src", $(this).attr("data-src"));
                            $(this).removeAttr("data-src");
                        }
                    });
                }
            })
        });

        $(".smallslider").each(function () {
            if (($(this).closest(".row").attr("id") != "more-aktuelles" && $(this).closest(".row").attr("id") != "more-hochbau" && $(this).closest(".row").attr("id") != "more-tiefbau" && $(this).closest(".row").attr("id") != "more-fraesen") || $(this).closest(".row").hasClass("slidersshouldbeloaded")) {
                $(this).find("IMG").each(function () {
                    if (typeof $(this).attr("data-src") != "undefined") {
                        $(this).attr("src", $(this).attr("data-src"));
                        $(this).removeAttr("data-src");
                    }
                });
            }
        });

        (<any>window).Slider.lasttimeaction = new Date().getTime();

        window.setInterval(function () {
            var now = new Date().getTime();
            if (now - (<any>window).Slider.lasttimeaction > 7500) {
                if ((<any>window).Slider.isPlaying) {
                    $(".slider").find(".arrow-right").trigger("click");
                }
            }
        }, 1000);
    }

    initSliders() {



        $(".slider").each(function () {
            var imgCount = 0;
            $(this).children(".imageholder").find(".image").each(function () {
                imgCount++;
                $(this).attr("data-pos", imgCount);
                if (imgCount > 1) {
                    $(this).css("display", "none");
                    $(this).addClass("further");
                } else {
                    var imgClass = "img_dt";
                    if ($(window).innerWidth() <= 760) {
                        imgClass = "img_800";
                    } else if ($(window).innerWidth() <= 1250) {
                        imgClass = "img_1350";
                    }
                    $(this).find("IMG." + imgClass).each(function (e) {
                        if (typeof $(this).attr("data-src") != "undefined") {
                            $(this).attr("src", $(this).attr("data-src"));
                            $(this).removeAttr("data-src");
                        }
                    });
                }
            })

            if (imgCount > 1) {

                $(this).append("<div class='dots'></div>");
                for (var i = 0; i < imgCount; i++) {
                    $(this).find(".dots").append("<a href='#' data-pos='" + (i + 1) + "' aria-label='zu Bild " + (i + 1) + "' aria-hidden='true'></a>");
                }

                $(this).append("<a href='#' class='arrow-left' aria-label='Vorheriges Bild'></a>");
                $(this).append("<a href='#' class='arrow-right' aria-label='Nächstes Bild'></a>");

                $(this).attr("data-current", 1);
                $(this).attr("data-max", imgCount);
                $(this).find(".dots A[data-pos=1]").addClass("active");

                //Interaction
                $(this).find(".dots A").click(function (e) {
                    e.preventDefault();
                    if ($(this).closest(".slider").hasClass("ani"))
                        return;

                    (<any>window).Slider.lasttimeaction = new Date().getTime();

                    var mypos = Number($(this).attr("data-pos"));
                    var current = Number($(this).closest(".slider").attr("data-current"));

                    if (mypos > current) {
                        $(this).closest(".slider").find(".dots A").removeClass("active");
                        let $obj = $(this).closest(".slider").find(".imageholder .image[data-pos=" + mypos + "]");
                        $obj.css("display", "block").css("left", $(this).closest(".slider").width()).animate(
                            {
                                "left": 0
                            },
                            {
                                duration: 400,
                                complete: function () {
                                    var current = Number($(this).attr("data-pos"));
                                    $(this).closest(".slider").attr("data-current", current);
                                    $(this).closest(".slider").find(".dots A[data-pos=" + current + "]").addClass("active");
                                    $(this).closest(".slider").removeClass("ani");

                                    // alle dazwischen rein
                                    for (var i = 2; i < current; i++) {
                                        $(this).closest(".slider").find(".imageholder .image[data-pos=" + i + "]").css("left", 0).css("display", "block");
                                    }
                                }
                            }
                        );
                    } else {
                        $(this).closest(".slider").find(".dots A").removeClass("active");
                        let $obj = $(this).closest(".slider").find(".imageholder .image[data-pos=" + mypos + "]");
                        $obj.addClass("toplayer");
                        $obj.css("display", "block").css("left", -$(this).closest(".slider").width()).animate(
                            {
                                "left": 0
                            },
                            {
                                duration: 400,
                                complete: function () {
                                    var current = Number($(this).attr("data-pos"));
                                    $(this).closest(".slider").attr("data-current", current);
                                    $(this).closest(".slider").find(".dots A[data-pos=" + current + "]").addClass("active");
                                    $(this).closest(".slider").removeClass("ani");

                                    // alle drüber raus
                                    var max = Number($(this).closest(".slider").attr("data-max"));
                                    for (var i = current + 1; i <= max; i++) {
                                        $(this).closest(".slider").find(".imageholder .image[data-pos=" + i + "]").css("left", 0).css("display", "none");
                                    }
                                    $obj.removeClass("toplayer");
                                }
                            }
                        );
                    }
                });

                $(this).find(".arrow-left").click(function (e) {
                    e.preventDefault();
                    if ($(this).closest(".slider").hasClass("ani"))
                        return;

                    (<any>window).Slider.lasttimeaction = new Date().getTime();

                    var current = Number($(this).closest(".slider").attr("data-current"));
                    var max = Number($(this).closest(".slider").attr("data-max"));
                    var newpos = current - 1;
                    if (newpos < 1) {
                        // das letzte von links rein
                        $(this).closest(".slider").find(".dots A").removeClass("active");
                        let $obj = $(this).closest(".slider").find(".imageholder .image[data-pos=" + max + "]");
                        $obj.css("display", "block").css("left", -$(this).closest(".slider").width()).animate(
                            {
                                "left": 0
                            },
                            {
                                duration: 400,
                                complete: function () {
                                    var current = Number($(this).closest(".slider").attr("data-max"));
                                    $(this).closest(".slider").attr("data-current", current);
                                    $(this).closest(".slider").find(".dots A[data-pos=" + current + "]").addClass("active");
                                    $(this).closest(".slider").removeClass("ani");

                                    // alle dazwischen rein
                                    for (var i = 2; i < current; i++) {
                                        $(this).closest(".slider").find(".imageholder .image[data-pos=" + i + "]").css("left", 0).css("display", "block");
                                    }
                                }
                            }
                        );
                    } else {
                        // eins nach links
                        $(this).closest(".slider").find(".dots A").removeClass("active");
                        let $obj = $(this).closest(".slider").find(".imageholder .image[data-pos=" + current + "]");
                        $obj.animate(
                            {
                                "left": $(this).closest(".slider").width()
                            },
                            {
                                duration: 400,
                                complete: function () {
                                    var current = Number($(this).closest(".slider").attr("data-current"));
                                    $(this).closest(".slider").attr("data-current", current - 1);
                                    $(this).closest(".slider").find(".dots A[data-pos=" + (current - 1) + "]").addClass("active");
                                    $(this).closest(".slider").removeClass("ani");
                                }
                            }
                        );
                    }
                })
                $(this).find(".arrow-right").click(function (e) {
                    e.preventDefault();
                    if ($(this).closest(".slider").hasClass("ani"))
                        return;

                    (<any>window).Slider.lasttimeaction = new Date().getTime();

                    var current = Number($(this).closest(".slider").attr("data-current"));
                    var max = Number($(this).closest(".slider").attr("data-max"));
                    var newpos = current + 1;
                    if (newpos > max) {
                        // zurück zum Anfang
                        $(this).closest(".slider").addClass("ani");
                        $(this).closest(".slider").find(".dots A").removeClass("active");
                        for (var i = 2; i < current; i++) {
                            $(this).closest(".slider").find(".imageholder .image[data-pos=" + i + "]").css("display", "none");
                        }
                        let $obj = $(this).closest(".slider").find(".imageholder .image[data-pos=" + current + "]");
                        $obj.animate(
                            {
                                "left": -$(this).closest(".slider").width()
                            },
                            {
                                duration: 400,
                                complete: function () {
                                    $(this).closest(".slider").attr("data-current", 1);
                                    $(this).closest(".slider").find(".dots A[data-pos=" + 1 + "]").addClass("active");
                                    $(this).closest(".slider").removeClass("ani");
                                }
                            }
                        );
                    } else {
                        // weiter nach rechts
                        $(this).closest(".slider").addClass("ani");
                        $(this).closest(".slider").find(".dots A").removeClass("active");
                        let $obj = $(this).closest(".slider").find(".imageholder .image[data-pos=" + newpos + "]");
                        $obj.css("left", $(this).closest(".slider").width()).css("display", "block").animate(
                            {
                                "left": 0
                            },
                            {
                                duration: 400,
                                complete: function () {
                                    var current = Number($(this).closest(".slider").attr("data-current"));
                                    $(this).closest(".slider").attr("data-current", current + 1);
                                    $(this).closest(".slider").find(".dots A[data-pos=" + (current + 1) + "]").addClass("active");
                                    $(this).closest(".slider").removeClass("ani");
                                }
                            }
                        );
                    }
                })


                $(this).on("click", ".toggle-autoplay", function (e) {
                    e.preventDefault();
                    console.log("toggleAutoplay");

                    if ((<any>window).Slider.isPlaying) {
                        $(this).removeClass("is-playing")
                            .addClass("is-paused")
                            .attr("aria-label", "Autoplay starten");
                    }
                    else {
                        $(this).removeClass("is-paused")
                            .addClass("is-playing")
                            .attr("aria-label", "Autoplay pausieren");
                    }

                    (<any>window).Slider.isPlaying = !(<any>window).Slider.isPlaying;
                })

            }
        });
    }


}